import { render, staticRenderFns } from "./ResponsiveStepper.vue?vue&type=template&id=0c64dd2c&"
import script from "./ResponsiveStepper.vue?vue&type=script&lang=js&"
export * from "./ResponsiveStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepper } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepper})
